module.exports = __webpack_public_path__ + "static/img/portafolioAppMarcoAldany.b347aba.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/portfolioApp/portafolioAppMarcoAldany.webp
// module id = 473
// module chunks = 1